import { gql } from '@apollo/client'

// In-app walkthroughs (Maestro schema, gem `Maestro::Recruiter::Walkthroughs`). Content is authored per tenant in
// ActiveAdmin and matched by `screenKey`. Completed or skipped walkthroughs are not returned again.
export const ACTIVE_WALKTHROUGHS_QUERY = gql`
	query activeWalkthroughs($screenKey: String!) {
		activeWalkthroughs(screenKey: $screenKey) {
			id
			key
			version
			screenKey
			autoStart
			priority
			status
			currentStep
			steps {
				id
				position
				target
				placement
				title
				body
				primaryActionLabel
				secondaryActionLabel
			}
		}
	}
`

const STATE_FIELDS = 'id walkthroughId status currentStep'

export const START_WALKTHROUGH_MUTATION = gql`
	mutation startWalkthrough($walkthroughId: ID!) { startWalkthrough(walkthroughId: $walkthroughId) { ${STATE_FIELDS} } }
`
export const PROGRESS_WALKTHROUGH_MUTATION = gql`
	mutation progressWalkthrough($walkthroughId: ID!, $currentStep: Int!) { progressWalkthrough(walkthroughId: $walkthroughId, currentStep: $currentStep) { ${STATE_FIELDS} } }
`
export const COMPLETE_WALKTHROUGH_MUTATION = gql`
	mutation completeWalkthrough($walkthroughId: ID!) { completeWalkthrough(walkthroughId: $walkthroughId) { ${STATE_FIELDS} } }
`
export const SKIP_WALKTHROUGH_MUTATION = gql`
	mutation skipWalkthrough($walkthroughId: ID!) { skipWalkthrough(walkthroughId: $walkthroughId) { ${STATE_FIELDS} } }
`
